// import waypoints from node_modules
import 'waypoints/lib/jquery.waypoints';
import 'waypoints/lib/shortcuts/sticky';

export default () => {

  (function(window, document, $) {

    jQuery(document).ready(function($) {

      $(document.body).waypoint(function(direction) {
        if (direction === 'down') {
          document.body.style.paddingTop = `${document.querySelector('.header').clientHeight ?? 0}px`;
          document.querySelector('.header').classList.add('is-fixed');
        }
      }, {
        offset: '-300px',
      });

      document.addEventListener('scroll', () => {
        if ($(document).scrollTop() <= 0) {
          document.body.style.paddingTop = '0px';
          document.querySelector('.header').classList.remove('is-fixed');
        }
      });

    });
  }(window, document, jQuery));
}
